import { createSlice } from "@reduxjs/toolkit";
import { logout } from "./userSlice";
import { uniqueId } from "lodash-es";

const initialState = {
	isLoading: false,
	infoModal: {
		visible: false,
		header: null,
		content: null,
		accept: null,
	},
	alerts: [],
	alertAction:{},
	parameters:null
};

export const globalSlice = createSlice({
	name: "global",
	initialState,
	reducers: {
		updateParameters: (state, action) => {
			state.parameters = action.payload;
		},
		updateIsLoading: (state, action) => {
			state.isLoading = action.payload;
		},
		updateInfoModal: (state, action) => {
			state.infoModal = { ...action.payload };
		},
		updateAlert: (state, action) => {
			state.alerts = [...state.alerts, { ...action.payload, id: uniqueId("global_alert_") }];
		},
		clearAlert: (state, action) => {
			state.alerts = state.alerts.filter((alert) => alert.id !== action.payload);
		},
		updateAlertAction: (state, action) => {
			state.alertAction = action.payload;
		},
		purgeAlert: (state) => {
			state.alerts = [];
		},
	},
	extraReducers: (builder) => {
		builder.addCase(logout, (state) => {
			return { ...initialState, account: state.account };
		});
	},
});

export const { updateParameters,updateIsLoading, updateInfoModal, updateAlert, clearAlert, purgeAlert,updateAlertAction } = globalSlice.actions; //給React組件個別使用
export default globalSlice.reducer; //給store.js使用
